module.exports = __webpack_public_path__ + "img/ch.d139073a.svg";